module.exports = "/assets/99d210cf14866a0dc58a1ae27e7699cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SU.png
// module id = 1834
// module chunks = 0